<!-- @catalog Removable chip shown inside inputs / multi-selects (the chips in CInputSelect). For a standalone chip or status tag use CBadge (removable via the removable prop). -->
<template>
  <c-badge :removable :label :color :tooltip @remove="$emit('remove')" />
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    color?:
      | "primary"
      | "secondary"
      | "info"
      | "warning"
      | "negative"
      | "positive"
      | "blue"
      | "aqua"
      | "green"
      | "yellow"
      | "red"
      | "purple"
      | "grey"
      | "gray"
      | "portfolio-tag"
      | "portfolio-skill"
      | "portfolio-lob_competence"
      | "portfolio-concept";
    tooltip?: string | null;
    label: string | number;
    removable?: boolean;
  }>(),
  {
    color: "primary",
    removable: false,
  },
);

defineEmits<{
  (event: "remove"): void;
}>();
</script>

<style lang="scss" scoped>
div.q-badge {
  @apply tw-max-h-6 tw-max-w-40 tw-select-none tw-gap-2 tw-overflow-hidden tw-rounded tw-px-2 tw-py-0.5;

  > span {
    @apply tw-truncate tw-text-xs tw-font-medium;
  }

  .c-input-chip__remove {
    @apply tw-cursor-pointer tw-opacity-60 tw-transition-opacity;

    &:hover {
      @apply tw-opacity-100;
    }
  }
}
</style>
